











import { Component, Vue, Prop } from 'vue-property-decorator'
import 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/skins/content/default/content.min.css'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/link'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/image'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/code'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/print'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/media'
import 'tinymce/plugins/help'
import 'tinymce/plugins/table'
import 'tinymce/plugins/importcss'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/template'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/toc'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/textpattern'
import 'tinymce/plugins/noneditable'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/autosave'

import { Helper } from '@/helpers/Helper'
import { Api } from '@/fetch/Api'

@Component({
  components: {
    Editor,
  },
})
export default class TinyMCE extends Vue {
  @Prop() public content!: string;
  @Prop() public title!: string;
  @Prop() public siteCss!: string;

  public onContentReady(event, editor) {
    this.$emit('update-content', editor.getContent(), this.title)
  }

  get configuration() {
    return {
      skin: false,
      content_css: false,
      object_resizing: true,
      height: 500,
      menubar: false,
      plugins: [
        'code table advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks fullscreen',
        'insertdatetime media paste help wordcount',
      ],
      contextmenu: false,
      toolbar:
        'code | undo redo | formatselect | table | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image | blockquote | anchor link | removeformat | help',
      content_style: 'body{padding:20px !important}' + this.siteCss + '.super {position:unset} p > br:only-child {display: block;}',
      body_class: 'para',
      formats: {
        alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-left' },
        alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-right' },
        aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-center' },
        blockquote: { block: 'div', classes: 'Q5' },
        italic: { inline: 'i' },
      },
      convert_newlines_to_br: false,
      images_upload_handler: this.example_image_upload_handler,
      relative_urls: false,
      remove_script_host: false,
      document_base_url: Helper.getCurrentDomain(),
      valid_elements: '@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|' +
     'onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|' +
     'onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|' +
     'name|href|target|title|class|onfocus|onblur],strong/b,em,i,strike,u,' +
     '#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|' +
     'src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,' +
     '-blockquote,-table[border=0|cellspacing|cellpadding|width|frame|rules|' +
     'height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|' +
     'height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,' +
     '#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor' +
     '|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,div[class],' +
     '-span,-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face' +
     '|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],' +
     'object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width' +
     '|height|src|*],script[src|type|defer],map[name],area[shape|coords|href|alt|target],bdo,' +
     'button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|' +
     'valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],' +
     'input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],' +
     'kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],' +
     'q[cite],samp,select[disabled|multiple|name|size],small,' +
     'textarea[cols|rows|disabled|name|readonly],tt,var,big,iframe[src|frameborder|style|scrolling|class|width|height|name|align]',
    }
  }

  public example_image_upload_handler(blobInfo, success, failure, progress) {
    const xhr = new XMLHttpRequest()
    xhr.withCredentials = false

    xhr.open('POST', Api.getBaseUrl() + '/domain/image')

    xhr.setRequestHeader('Authorization', 'Bearer ' + Api.getBearerToken())

    xhr.upload.onprogress = function (e) {
      progress(e.loaded / e.total * 100)
    }

    xhr.onload = function () {
      if (xhr.status === 403) {
        failure('HTTP Error: ' + xhr.status, { remove: true })
        return
      }

      if (xhr.status < 200 || xhr.status >= 300) {
        switch (xhr.status) {
          case 413:
            failure('Files larger than 2MB can not be uploaded!')
            break
          default:
            failure('HTTP Error: ' + xhr.status)
        }
        return
      }

      const json = JSON.parse(xhr.responseText)

      if (!json || typeof json.location !== 'string') {
        failure('Invalid JSON: ' + xhr.responseText)
        return
      }

      success(json.location)
    }

    xhr.onerror = function () {
      failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status)
    }

    const formData = new FormData()
    formData.append('image', blobInfo.blob(), blobInfo.filename())

    xhr.send(formData)
  }
}
